import React from "react"
import styled from "styled-components"

import { Color } from "~/consts/style-mixins"
import Alarm from "~/svgs/alarm.svg"
import Apply from "~/svgs/apply.svg"
import Area from "~/svgs/area.svg"
import Back from "~/svgs/back.svg"
import Bag from "~/svgs/bag.svg"
import Batch from "~/svgs/batch.svg"
import Cancel from "~/svgs/cancel.svg"
import Clip from "~/svgs/clip.svg"
import Clock from "~/svgs/clock.svg"
import Close from "~/svgs/close.svg"
import Company from "~/svgs/company.svg"
import Delete from "~/svgs/delete.svg"
import Done from "~/svgs/done.svg"
import Error from "~/svgs/error.svg"
import Es from "~/svgs/es.svg"
import FavoriteFill from "~/svgs/favorite_fill.svg"
import FavoriteStroke from "~/svgs/favorite_stroke.svg"
import Fire from "~/svgs/fire.svg"
import Gift from "~/svgs/gift.svg"
import Hamburger from "~/svgs/hamburger.svg"
import Leader from "~/svgs/leader.svg"
import Light from "~/svgs/light.svg"
import Line from "~/svgs/line.svg"
import Loading from "~/svgs/loading.svg"
import Message from "~/svgs/message.svg"
import Minus from "~/svgs/minus.svg"
import Money from "~/svgs/money.svg"
import Next from "~/svgs/next.svg"
import NoItem from "~/svgs/no_item.svg"
import Open from "~/svgs/open.svg"
import Photo from "~/svgs/photo.svg"
import Plus from "~/svgs/plus.svg"
import QuestionMark from "~/svgs/question-mark.svg"
import Repeat from "~/svgs/repeat.svg"
import Search from "~/svgs/search.svg"
import Send from "~/svgs/send.svg"
import Shirt from "~/svgs/shirt.svg"
import Success from "~/svgs/success.svg"
import User from "~/svgs/user.svg"

interface Props {
  type: IconType
  size?: number
  width?: number
  height?: number
  color?: string
  className?: string
}

interface StyledProps {
  color?: string
  size?: number
  width?: number
  height?: number
}

const Icon = ({ type, size, width, height, color, className }: Props) => {
  return (
    <StyledSvgWrapper className={className} size={size} width={width} height={height} color={color}>
      {IconType[type]}
    </StyledSvgWrapper>
  )
}

export type IconType = keyof typeof IconType
export const IconType = {
  Hamburger: <Hamburger />,
  Next: <Next />,
  Back: <Back />,
  Open: <Open />,
  Close: <Close />,
  Company: <Company />,
  Search: <Search />,
  Message: <Message />,
  Apply: <Apply />,
  User: <User />,
  FavoriteStroke: <FavoriteStroke />,
  Fire: <Fire />,
  FavoriteFill: <FavoriteFill />,
  Success: <Success />,
  Line: <Line />,
  Error: <Error />,
  Loading: <Loading />,
  Area: <Area />,
  Batch: <Batch />,
  Money: <Money />,
  Clock: <Clock />,
  Repeat: <Repeat />,
  Shirt: <Shirt />,
  Bag: <Bag />,
  Photo: <Photo />,
  Leader: <Leader />,
  Plus: <Plus />,
  Minus: <Minus />,
  Delete: <Delete />,
  Es: <Es />,
  Cancel: <Cancel />,
  Light: <Light />,
  Clip: <Clip />,
  Send: <Send />,
  NoItem: <NoItem />,
  QuestionMark: <QuestionMark />,
  Done: <Done />,
  Alarm: <Alarm />,
  Gift: <Gift />,
}

const StyledSvgWrapper = styled.div`
  display: inline-flex;
  width: ${({ size, width }: StyledProps) => width || size}px;
  height: ${({ size, height }: StyledProps) => height || size}px;

  svg {
    flex: 1;
    fill: ${({ color }: StyledProps) => color ?? Color.Black};
  }
`

export default Icon
